<template>
    <div>
        <Modal
            :value="modalData.show"
            :title="modalData.type === 1 ? '新建套餐' : '编辑套餐'"
            @on-cancel="cancel"
            @on-visible-change="onVisibleChange"
            :mask-closable="false"
            width="900"
            transfer
        >
            <div class="package-form">
                <!-- 基本信息 -->
                <div class="form-section">
                    <div class="section-title">基本信息</div>
                    <Form label-position="top">
                        <Row :gutter="24">
                            <Col span="12">
                                <FormItem label="套餐名称">
                                    <Input
                                        v-model="formData.combo_name"
                                        placeholder="请输入套餐名称"
                                    />
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="套餐类型">
                                    <Select v-model="formData.combo_type">
                                        <Option value="1">固定搭配</Option>
                                        <Option value="2">随心选</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <FormItem label="套餐图片">
                            <div class="upload-box">
                                <!-- 已上传图片预览 -->
                                <div v-if="formData.combo_img_domain" class="cover-preview">
                                    <Icon class="delete-icon" type="ios-close-circle" @click="deleteCover" />
                                    <img :src="formData.combo_img_domain" alt="套餐封面" />
                                </div>
                                <!-- 上传按钮 -->
                                <Upload
                                    ref="upload"
                                    :show-upload-list="false"
                                    :format="['jpg', 'jpeg', 'png']"
                                    :max-size="2048"
                                    :headers="header"
                                    :on-format-error="handleFormatError"
                                    :on-success="uploadImgSuccess"
                                    :on-progress="handleProgress"
                                    :action="uploads"
                                >
                                    <div class="upload-placeholder">
                                        <Icon type="ios-add" size="60" style="color: #9ea6b9" />
                                        <p class="upload-tip">建议尺寸 200×200px</p>
                                    </div>
                                </Upload>
                            </div>
                        </FormItem>
                        <FormItem label="套餐价格 (¥)">
                            <Input
                                v-model="formData.combo_price"
                                style="width: 100%"
                                placeholder="输入套餐价格"
                            />
                        </FormItem>
                    </Form>
                </div>

                <!-- 搭配规则 - 固定搭配 -->
                <div v-if="formData.combo_type == 1" class="form-section">
                    <div class="section-title">搭配规则 (固定搭配)</div>
                    <div class="dish-list">
                        <div
                            v-for="(dish, index) in formData.goods_ids"
                            :key="index"
                            class="dish-item"
                        >
                            <span>{{ dish.goods_name }}</span>
                            <Icon
                                type="ios-remove-circle-outline"
                                size="20"
                                color="#ff4d4f"
                                style="cursor: pointer"
                                @click="deleteFixedDish(index)"
                            />
                        </div>
                        <Button
                            type="dashed"
                            long
                            @click="openSelectFixedDish"
                            style="margin-top: 10px"
                        >
                            + 添加菜品
                        </Button>
                    </div>
                </div>

                <!-- 搭配规则 - 随心选 -->
                <div v-if="formData.combo_type == 2" class="form-section">
                    <div class="section-title">搭配规则 (随心选)</div>
                    <div
                        v-for="(rule, ruleIndex) in formData.rules"
                        :key="ruleIndex"
                        class="rule-item"
                    >
                        <div class="rule-header">
                            <Input
                                v-model="rule.ruleName"
                                placeholder="规则名称"
                                style="width: 200px; margin-right: 10px"
                            />
                            <span style="margin-right: 10px">必选个数</span>
                            <InputNumber
                                v-model="rule.requiredCount"
                                :min="1"
                                style="width: 100px; margin-right: 10px"
                            />
                            <Icon
                                type="ios-close-circle"
                                size="20"
                                color="#ff4d4f"
                                style="cursor: pointer"
                                @click="deleteRule(ruleIndex)"
                            />
                        </div>
                        <div class="dish-list">
                            <div class="dish-item-header">
                                <span>可选菜品</span>
                            </div>
                            <div
                                v-for="(dish, dishIndex) in rule.dishes"
                                :key="dishIndex"
                                class="dish-item"
                            >
                                <span>{{ dish.goods_name }}</span>
                                <div class="dish-actions">
                                    <span style="margin-right: 10px"
                                        >加价 ¥</span
                                    >
                                    <InputNumber
                                        v-model="dish.extraPrice"
                                        :min="0"
                                        :precision="2"
                                        style="width: 100px; margin-right: 10px"
                                    />
                                    <Icon
                                        type="ios-remove-circle-outline"
                                        size="20"
                                        color="#ff4d4f"
                                        style="cursor: pointer"
                                        @click="
                                            deleteDish(ruleIndex, dishIndex)
                                        "
                                    />
                                </div>
                            </div>
                            <Button
                                type="dashed"
                                long
                                @click="openSelectDish(ruleIndex)"
                                style="margin-top: 10px"
                            >
                                + 增加菜品
                            </Button>
                        </div>
                    </div>
                    <Button
                        type="dashed"
                        long
                        @click="addRule"
                        style="margin-top: 10px"
                    >
                        + 添加规则类型
                    </Button>
                </div>
            </div>

            <div slot="footer">
                <Button @click="cancel">取消</Button>
                <Button
                    style="background: #ff761d; border-color: #ff761d"
                    @click="submit"
                    type="primary"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 选择菜品弹窗 -->
        <select-dish
            v-show="selectDishModal.show"
            :value="selectDishModal.show"
            :modal-data="selectDishModal"
            @input="(val) => (selectDishModal.show = val)"
            @confirm="handleDishConfirm"
        ></select-dish>
    </div>
</template>

<script>
import { saveCombo, comboDetail } from "@/api/customer";
import SelectDish from "./selectDish.vue";
import config from "@/config";
import { getCookies } from "@/utils/helper";

export default {
    components: { SelectDish },
    name: "editPackage",
    props: {
        modalData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            header: {
                "hlzw-canyin-authori-zation": getCookies("hlzw_canyin_token"),
            },
            uploads: config.apiUrl + "/storeapi/data/uploads",
            formData: {
                id: "",
                combo_type: "1",
                combo_name: "",
                combo_price: "",
                combo_img: "",
                combo_img_domain: "", // 用于显示图片的完整URL
                goods_ids: [], // 固定搭配菜品
                rules: [], // 随心选规则
            },
            selectDishModal: {
                show: false,
                ruleIndex: null, // 当前操作的规则索引，null表示固定搭配
            },
        };
    },
    watch: {
        "modalData.show": {
            handler(val) {
                if (val && this.modalData.type === 2 && this.modalData.id) {
                    // TODO: 加载套餐详情
                    this.loadPackageDetail(this.modalData.id);
                } else if (val && this.modalData.type === 1) {
                    this.resetForm();
                }
            },
        },
    },
    methods: {
        resetForm() {
            this.formData = {
                id: "",
                combo_type: "1",
                combo_name: "",
                combo_price: "",
                combo_img: "",
                combo_img_domain: "",
                goods_ids: [], // 固定搭配菜品
                rules: [], // 随心选规则
            };
        },
        loadPackageDetail(id) {
            comboDetail({ id: id })
                .then((res) => {
                    const data = res.data;
                    this.formData.id = data.id;
                    this.formData.combo_type = String(data.combo_type);
                    this.formData.combo_name = data.combo_name || "";
                    this.formData.combo_price = data.combo_price || "";
                    this.formData.combo_img = data.combo_img || "";
                    this.formData.combo_img_domain = data.combo_img_domain || "";

                    // 处理固定搭配的菜品数据
                    if (data.goods_ids && Array.isArray(data.goods_ids)) {
                        // 后端返回格式: [{id, name, goods_img}]
                        this.formData.goods_ids = data.goods_ids.map(
                            (dish) => ({
                                id: dish.id,
                                goods_name: dish.name || dish.goods_name || `菜品${dish.id}`,
                                goods_img: dish.goods_img || "",
                            })
                        );
                    } else {
                        this.formData.goods_ids = [];
                    }

                    // 处理随心选的规则数据
                    if (data.rules && Array.isArray(data.rules)) {
                        this.formData.rules = data.rules.map((rule) => ({
                            ruleName: rule.rule_name || "",
                            requiredCount: rule.choose_num || 1,
                            dishes: (rule.products || []).map((product) => {
                                return {
                                    id: product.goods_id || product.id,  // 兼容两种字段名
                                    goods_name: product.name || `菜品${product.goods_id || product.id}`,
                                    extraPrice: parseFloat(product.markup) || 0,
                                    goods_img: product.goods_img || "",
                                };
                            }),
                        }));
                    } else {
                        this.formData.rules = [];
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "加载套餐详情失败");
                });
        },
        cancel() {
            this.closeModal();
        },
        onVisibleChange(visible) {
            if (!visible) {
                this.closeModal();
            }
        },
        closeModal() {
            this.$emit("input", false);
            const updatedModal = { ...this.modalData, show: false };
            this.$emit("update:modalData", updatedModal);
        },
        submit() {
            // 构建符合API要求的参数
            const params = {
                id: this.formData.id || undefined,
                combo_type: parseInt(this.formData.combo_type),
                combo_name: this.formData.combo_name,
                combo_price: parseFloat(this.formData.combo_price) || 0,
                combo_img: this.formData.combo_img,
            };

            // 固定搭配类型 (combo_type = 1)
            if (this.formData.combo_type == 1) {
                if (this.formData.goods_ids.length === 0) {
                    this.$Message.warning("请添加至少一个菜品");
                    return;
                }
                // goods_ids: 传递菜品ID数组
                params.goods_ids = this.formData.goods_ids.map((dish) => dish.id);
            }
            // 随心选类型 (combo_type = 2)
            else if (this.formData.combo_type == 2) {
                if (this.formData.rules.length === 0) {
                    this.$Message.warning("请添加至少一个规则");
                    return;
                }
                // rules: 构建规则数组（按照API文档要求）
                params.rules = this.formData.rules.map((rule, ruleIdx) => {
                    return {
                        rule_name: rule.ruleName,
                        choose_num: rule.requiredCount,
                        products: rule.dishes.map((dish, dishIdx) => {
                            return {
                                goods_id: dish.id,
                                name: dish.goods_name,
                                goods_img: dish.goods_img || "",
                                markup: dish.extraPrice || 0,
                            };
                        }),
                    };
                });
            }

            saveCombo(params)
                .then((res) => {
                    this.$Message.success(res.msg || "操作成功");
                    this.$emit("refresh");
                    this.closeModal();
                })
                .catch((err) => {
                    console.error("提交失败:", err);
                    this.$Message.error(err.msg || "操作失败");
                });
        },
        deleteCover() {
            this.formData.combo_img = "";
            this.formData.combo_img_domain = "";
        },
        handleFormatError() {
            this.$Message.warning("暂不支持上传此格式");
        },
        uploadImgSuccess(e) {
            if (e.code == 400) {
                this.$Message.destroy();
                this.$Message.error(e.msg);
            } else {
                this.formData.combo_img_domain = e.data.path;
                this.formData.combo_img = e.data.src;
                this.$Message.destroy();
                this.$Message.success(e.msg);
            }
        },
        handleProgress() {
            this.$Message.loading({
                content: "上传中...",
                duration: 0,
            });
        },
        addRule() {
            this.formData.rules.push({
                ruleName: "",
                requiredCount: 1,
                dishes: [],
            });
        },
        deleteRule(index) {
            this.formData.rules.splice(index, 1);
        },
        openSelectDish(ruleIndex) {
            this.selectDishModal.ruleIndex = ruleIndex;
            this.selectDishModal.show = true;
        },
        openSelectFixedDish() {
            this.selectDishModal.ruleIndex = null;
            this.selectDishModal.show = true;
        },
        handleDishConfirm(dishes) {
            if (this.selectDishModal.ruleIndex !== null) {
                // 添加到随心选规则
                const ruleIndex = this.selectDishModal.ruleIndex;
                dishes.forEach((dish) => {
                    this.formData.rules[ruleIndex].dishes.push({
                        id: dish.id,
                        goods_name: dish.goods_name,
                        extraPrice: 0,
                    });
                });
            } else {
                // 添加到固定搭配
                dishes.forEach((dish) => {
                    this.formData.goods_ids.push({
                        id: dish.id,
                        goods_name: dish.goods_name,
                    });
                });
            }
        },
        deleteDish(ruleIndex, dishIndex) {
            this.formData.rules[ruleIndex].dishes.splice(dishIndex, 1);
        },
        deleteFixedDish(index) {
            this.formData.goods_ids.splice(index, 1);
        },
    },
};
</script>

<style scoped>
.package-form {
    padding-right: 4px;
}
.form-section {
    margin-bottom: 30px;
}
.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 3px solid #ff761d;
}
.upload-box {
    display: flex;
    align-items: center;
}
.cover-preview {
    position: relative;
    width: 105px;
    height: 105px;
    border-radius: 5px;
    overflow: visible;
    border: 1px solid #999;
    margin-right: 20px;
}
.cover-preview img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    object-fit: cover;
}
.delete-icon {
    position: absolute;
    top: -8px;
    right: -8px;
    background: rgba(255, 77, 79, 0.9);
    color: white;
    border-radius: 50%;
    cursor: pointer;
    font-size: 16px;
    padding: 3px;
    transition: all 0.3s;
}
.delete-icon:hover {
    background: rgba(255, 77, 79, 1);
    transform: scale(1.1);
}
.upload-placeholder {
    width: 105px;
    height: 105px;
    border: 1px dashed #a0a4bd;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    background: #f7f8fa;
}
.upload-placeholder:hover {
    border-color: #ff761d;
    background: #fff7e6;
}
.upload-placeholder .ivu-icon {
    color: #9ea6b9;
    margin-bottom: 5px;
}
.upload-tip {
    font-size: 12px;
    color: #c0c4cc;
    margin: 3px 0 0 0;
    text-align: center;
    line-height: 1.4;
}
.rule-item {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;
}
.rule-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}
.dish-list {
    margin-left: 20px;
}
.dish-item-header {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
}
.dish-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #f0f0f0;
}
.dish-item:last-child {
    border-bottom: none;
}
.dish-actions {
    display: flex;
    align-items: center;
}
</style>

<style>
.ivu-modal-body {
    overflow-x: hidden;
}
.ivu-btn-primary {
    background: #ff761d;
    border-color: #ff761d;
}
.ivu-btn-primary:hover {
    background: #ff761d;
    border-color: #ff761d;
}
</style>
